import { Seo } from '../components/Seo';
import { Hero } from '../sections/Hero';
import { Problems } from '../sections/Problems';
import { HowItWorks } from '../sections/HowItWorks';
import { Features } from '../sections/Features';
import { Pricing } from '../sections/Pricing';
import { Faq } from '../sections/Faq';
import { FinalCta } from '../sections/FinalCta';
import { StructuredData } from '../components/StructuredData';

export default function HomePage() {
  return (
    <>
      <Seo path="/" />
      <StructuredData />
      <div className="container">
        <Hero />
        <Problems />
        <HowItWorks />
        <Features />
        <Pricing />
        <Faq />
        <FinalCta />
      </div>
    </>
  );
}
